import PropTypes from "prop-types";

import React from "react";

import * as ROUTES from "../../constants/routes.js";

import CareersHomePage from "./pages/CareersHomePage";
import RolePage from "./pages/RolePage";
import SubmissionErrorPage from "./pages/SubmissionErrorPage";
import ThankYouPage from "./pages/ThankYouPage";

import "./style.scss";

class CareersPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: null,
      pageStates: {
        [ROUTES.HOME_CAREERS]: "inactive",
        [ROUTES.CAREERS_ROLE]: "inactive",
        [ROUTES.CAREERS_THANK_YOU]: "inactive",
        [ROUTES.CAREERS_SUBMISSION_ERROR]: "inactive",
      },
      pagesReady: {
        [ROUTES.HOME_CAREERS]: false,
        [ROUTES.CAREERS_ROLE]: false,
        [ROUTES.CAREERS_THANK_YOU]: false,
        [ROUTES.CAREERS_SUBMISSION_ERROR]: false,
      },
      formError: null,
    };

    this.vars = {
      doWhenPageReady: {
        [ROUTES.HOME_CAREERS]: null,
        [ROUTES.CAREERS_ROLE]: null,
        [ROUTES.CAREERS_THANK_YOU]: null,
        [ROUTES.CAREERS_SUBMISSION_ERROR]: null,
      },
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    if (this.props.currentRoute !== prevProps.currentRoute) {
      Z.pageChanged();
    }
  }

  init = () => {
    const Z = this;

    Z.pageChanged();
  };

  pageChanged = () => {
    const Z = this;

    const prevPage = Z.state.currentPage;
    const currentPage = Z.props.currentRoute && Z.props.currentRoute.path;

    const activateDelay = 200; // milliseconds

    if (prevPage != currentPage) {
      Z.setState(
        (state) => {
          var pageStates = state.pageStates;
          if (prevPage != null) {
            pageStates[prevPage] =
              pageStates[prevPage] == "active" ? "active outtro" : "outtro";
          }
          if (currentPage != null) {
            pageStates[currentPage] = "initializing";
          }
          return { pageStates };
        },
        () => {
          setTimeout(() => {
            function makePageActive() {
              Z.setState((state) => {
                var pageStates = state.pageStates;
                if (prevPage != null) {
                  pageStates[prevPage] = "inactive";
                }
                if (currentPage != null) {
                  pageStates[currentPage] = "active";
                }
                return {
                  pageStates,
                  currentPage: currentPage,
                };
              });
            }
            // WARNING:  "setScroll" fucks up the page transitions!
            if (Z.state.pagesReady[currentPage] == false) {
              Z.vars.doWhenPageReady[currentPage] = () => makePageActive();
            } else {
              makePageActive();
            }
          }, activateDelay);
        }
      );
    }
  };

  setPageReady = (route, isReady) => {
    const Z = this;

    Z.setState((state) => {
      var pagesReady = state.pagesReady;
      pagesReady[route] = isReady;
      return { pagesReady };
    });

    if (
      Z.vars.doWhenPageReady[route] != null
    ) {
      if (isReady == true) {
        const cb =
          Z.vars.doWhenPageReady[route] ??
          (() => ({}));
        cb();
        Z.vars.doWhenPageReady[route] = null;
      }
    }
  };

  getScroll = () => {
    return document.documentElement.scrollTop || document.body.scrollTop;
  };

  setScroll = (pos) => {
    document.documentElement.scrollTop = document.body.scrollTop = pos;
  };

  setFormError = (error) => {
    this.setState({ formError: error });
  };

  render() {
    var Z = this;

    return (
      <div className="CareersPage">
        <div
          className={`career-page career-page-main ${
            Z.state.pageStates[ROUTES.HOME_CAREERS]
          }`}
        >
          <CareersHomePage
            currentRoute={Z.props.currentRoute}
            componentRoute={ROUTES.HOME_CAREERS}
            setReady={Z.setPageReady}
          />
        </div>
        <div
          className={`career-page career-page-role ${
            Z.state.pageStates[ROUTES.CAREERS_ROLE]
          }`}
        >
          <RolePage
            currentRoute={Z.props.currentRoute}
            componentRoute={ROUTES.CAREERS_ROLE}
            setReady={Z.setPageReady}
            setFormError={Z.setFormError}
          />
        </div>
        <div
          className={`career-page career-page-thank-you ${
            Z.state.pageStates[ROUTES.CAREERS_THANK_YOU]
          }`}
        >
          <ThankYouPage
            currentRoute={Z.props.currentRoute}
            componentRoute={ROUTES.CAREERS_THANK_YOU}
            setReady={Z.setPageReady}
          />
        </div>
        <div
          className={`career-page career-page-error ${
            Z.state.pageStates[ROUTES.CAREERS_SUBMISSION_ERROR]
          }`}
        >
          <SubmissionErrorPage
            currentRoute={Z.props.currentRoute}
            componentRoute={ROUTES.CAREERS_SUBMISSION_ERROR}
            setReady={Z.setPageReady}
            formError={Z.state.formError}
          />
        </div>
      </div>
    );
  }
}

CareersPage.propTypes = {
  // currentPage: PropTypes.string,
  // roleId: PropTypes.string,
  currentRoute: PropTypes.object,
};

export default CareersPage;
